module.exports = __webpack_public_path__ + "img/folder-open.b0780d8f.svg";